import { useState } from "react";

export default defaultValue => {
  const [state, setState] = useState(defaultValue);
  return { state, setState };
};
